import { Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, inject, viewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { ColumnMode, DatatableComponent, NgxDatatableModule, SelectionType } from '@swimlane/ngx-datatable';
import { lastValueFrom } from 'rxjs';
import { BarManagementService, IOrganizationQuery, Organization, OrganizationQuery } from 'src/app/api/api-bar-management.service.generated';
import { LocationFilterByOrganizationTag } from 'src/app/api/api-campaigns.service.generated';
import { TagQueryItem } from 'src/app/api/api-user-management.service.generated';
import { ConfirmDialogModel, ButtonComponent, DataTableComponent, TableColumn } from 'wecheer-common';

@Component({
  selector: 'app-filter-by-organization-tag',
  templateUrl: './filter-by-organization-tag.component.html',
  styleUrls: ['./filter-by-organization-tag.component.scss'],
  imports: [
    NgxDatatableModule,
    MatIconModule,
    ButtonComponent,
    DataTableComponent
  ]
})
export class FilterByOrganizationTagComponent implements OnInit, OnChanges {
  private dialog = inject(MatDialog);
  private bmApi = inject(BarManagementService);


  @Input() model: LocationFilterByOrganizationTag;
  @Output() delete = new EventEmitter<LocationFilterByOrganizationTag>();

  readonly datatable = viewChild<DatatableComponent>('datatable');
  readonly el = viewChild<ElementRef>('el');

  columns: TableColumn[] = [
    { name: 'name', header: 'Name' },
    { name: 'description', header: 'Description' }
  ]

  readonly headerHeight = 50;
  readonly rowHeight = 45;
  readonly pageLimit = 10;

  rows: Organization[] = [];
  filter: IOrganizationQuery;
  nextToken: string = null;
  selectedOrganization: Organization;
  isLoading: boolean;
  isLoadingDisabled = false; // disabled ngx-datatable internal loader
  isError = false;
  isErrorRetry = false;
  isFirstRequest = true;
  hasMoreItems = true;
  error = '';

  isAllSelected = false;
  included: string[] = [];
  ColumnMode = ColumnMode;
  SelectionType = SelectionType;

  total?: number;


  ngOnInit() {
  }

  ngOnChanges(): void {
    if (!this.model) return;

    const tags = this.model.tags.map(t => new TagQueryItem({ tag: t.tag, value: t.value }));
    this.filter = new OrganizationQuery({ tags: tags, skip: 0, maxItems: 10 * 1000 });
    setTimeout(() => {
      this.search(this.filter);
    }, 500);
  }


  onPageChanged(page: Organization[]) {
    if (!page) return;

    page.forEach(device => {
      const alreadySelected = this.datatable().selected.filter(d => d.name === device.name).length > 0;
      if (this.isAllSelected && !alreadySelected)
        this.datatable().selected.push(device);
    });
  }

  async search(f: IOrganizationQuery) {
    this.filter = f;
    this.nextToken = null;

    this.isFirstRequest = true;
    this.hasMoreItems = true;
    this.isError = false;
    this.isErrorRetry = false;
    this.rows = [];
    this.included = [];
    this.isAllSelected = false;

    // set the loading flag, which serves two purposes:
    // 1) it prevents the same page from being loaded twice
    // 2) it enables display of the loading indicator
    this.isLoading = true;
    this.isError = false;
    this.error = '';

    this.filter.nextToken = this.nextToken;

    try {
      const chunk = await lastValueFrom(this.bmApi.queryOrganizations(new OrganizationQuery(this.filter)));
      if (!chunk || !chunk.items)
        return;

      this.total = chunk.total;

      this.isErrorRetry = false;
      this.hasMoreItems = chunk.nextToken != null;
      this.rows = [...this.rows, ...chunk.items];

      this.nextToken = chunk.nextToken;

    } catch (error) {
      const err = error;
      this.isError = true;
      this.isErrorRetry = true;
      this.error = JSON.stringify(err);
    } finally {
      this.isFirstRequest = false;
      this.isLoading = false;
    }
  }



  async onDelete() {
    const dialogModel = ConfirmDialogModel.danger(
      'Are you sure you want to delete this filter??',
      'Delete filter?'
    );
    const confirmResult = await dialogModel.show(this.dialog);
    if (!confirmResult) return;

    this.delete.emit(this.model);
  }


}
